import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import styled from 'styled-components';

const StyledProgressBar = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: ${props => props.backgroundColor || "rgba(255, 255, 255, .7)"};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  ${props => props.rootStyles || ''}
`;

const StyledCircularProgress = styled(CircularProgress)`
  && {
    color: #004C6A !important;
    ${props => props.size === 'small' ? `
      width: 20px !important;
      height: 20px !important;
    ` : ''}
  }
`;

const ProgressBar = (props) => {
  return (
    <StyledProgressBar backgroundColor={props.backgroundColor} rootStyles={props.rootStyles}>
      <StyledCircularProgress size={props.size}/>
    </StyledProgressBar>
  );
}

export default ProgressBar;

ProgressBar.defaultProps = {
  size: 'medium',
  rootStyles: '',
  backgroundColor: "rgba(255, 255, 255, .7)",
}